import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import PredictionsPage from './pages/PredictionsPage';
import WorldCupPage from './pages/WorldCupPage';
import SharedPredictionPage from './pages/SharedPredictionPage';
import LastManStandingPage from './pages/LastManStandingPage';
import WCLastManStandingPage from './pages/WCLastManStandingPage';
import WCMatchPredictionsPage from './pages/WCMatchPredictionsPage';
import LeaguesPage from './pages/LeaguesPage';
import AdminPage from './pages/AdminPage';
import './i18n';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/share/:token" element={<SharedPredictionPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/predictions"
            element={
              <ProtectedRoute>
                <PredictionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/world-cup"
            element={
              <ProtectedRoute>
                <WorldCupPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/last-man-standing"
            element={
              <ProtectedRoute>
                <LastManStandingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wc-lms"
            element={
              <ProtectedRoute>
                <WCLastManStandingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/wc-match-predictions"
            element={
              <ProtectedRoute>
                <WCMatchPredictionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leagues"
            element={
              <ProtectedRoute>
                <LeaguesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#121212',
            color: '#FFFFFF',
            border: '1px solid #27272A',
          },
          className: 'sonner-toast',
        }}
      />
    </AuthProvider>
  );
}

export default App;
